import Repository from "./Repository";

const tokens = "/tokens";
const accessToken = "/access-token";
const ssoToken = "/sso-token";

export default {
  getAccessToken: (payload) => Repository.post(`${accessToken}/`, payload),
  validateAccount: (token) => Repository.post(`${tokens}/${token}/validate/`),
  resetEmailValidationToken: (data) =>
    Repository.post(`${tokens}/`, {
      context: "email_validation",
      user_email: data.email,
    }),
  resetPassword: (email) => Repository.post(`${tokens}/reset_password/`, email),
  changePassword: (passwordData) =>
    Repository.post(`${tokens}/change_password/`, passwordData),
  setPassword: (passwordData) =>
    Repository.post(`${tokens}/set_password/`, passwordData),
  verifyToken: (tokenData) =>
    Repository.post(`${tokens}/verify_token/`, tokenData),
  verifyOtp: (payload) => Repository.post(`${tokens}/verify_otp/`, payload),
  ssoToken: (payload) => Repository.post(`${ssoToken}/`, payload),
};
